export const INITIAL_STATE = {
  data: {
    deTokensById: {},
  },
  isLoading: false,
  error: null,
};
